module.exports = __webpack_public_path__ + "img/program-img_3.911ae394.png";